import classNames from 'classnames';
import DiagnosticResourceId from 'components/dev-tools/DiagnosticResourceId';
import Label from 'components/Label';
import type { BadgeIconValues } from 'components/projects/ProjectBadge';
import ProjectBadge from 'components/projects/ProjectBadge';
import Tooltip from 'components/Tooltip';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import type { ProjectBase } from 'types/project';
import { prefixHexColor } from 'utils/colors';
import { getProjectColor } from 'utils/project';
import type { TicMeta } from '~types/tic';
import styles from '../TableWidget.module.scss';

interface Props {
  project?: ProjectBase;
  icon?: BadgeIconValues;
  ticMeta?: TicMeta;
}

export const TableWidgetProjectBlock: React.FC<Props> = ({ project, ticMeta, icon }) => {
  if (!project) return <>—</>;

  return (
    <div className={classNames(styles.project, 'fs-mask')}>
      <ProjectBadge
        className={styles.badge}
        icon={icon}
        size="small"
        color={prefixHexColor(getProjectColor(project))}
        ticMeta={ticMeta || project.tic}
      />
      <span>
        <DiagnosticResourceId resource="project" id={project.id} />
        <span>
          {project.name}
          {!project.active && (
            <Tooltip title="Archived">
              <Label className={styles.archived}>
                <FontAwesome name="archive" />
              </Label>
            </Tooltip>
          )}
        </span>
        {project.client && (
          <span className={styles.clientName}>
            <DiagnosticResourceId resource="client" id={project.client.id} />
            {project.client.name}
          </span>
        )}
      </span>
    </div>
  );
};
